import { refreshMunicipalPropertyManagement } from "@/domain/municipal-property/lib/refresh-municipal-property-management";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { TrashEntityType } from "@ark/shared";
import { QueryClient, QueryKey } from "@tanstack/react-query";

interface TrashRefreshScope {
  workspaceId: string;
  idList: readonly string[];
}
interface TrashRefreshInput {
  queryClient: QueryClient;
  scope: TrashRefreshScope;
}
type RefreshTrashEntity = (input: TrashRefreshInput) => Promise<void>;
const invalidateAll =
  (queryKey: QueryKey): RefreshTrashEntity =>
  async ({ queryClient }: TrashRefreshInput): Promise<void> => {
    await queryClient.invalidateQueries({ queryKey });
  };
const REFRESH_BY_ENTITY_TYPE: Record<TrashEntityType, RefreshTrashEntity> = {
  climateAction: invalidateAll(queryKeys.climateActions.all),
  project: invalidateAll(queryKeys.projects.all),
  task: invalidateAll(queryKeys.tasks.all),
  indicator: invalidateAll(queryKeys.indicators.all),
  inventory: invalidateAll(queryKeys.inventories.all),
  municipalProperty: ({ queryClient, scope: { workspaceId, idList } }: TrashRefreshInput): Promise<void> =>
    refreshMunicipalPropertyManagement({
      queryClient,
      scope: { workspaceId, propertyIdList: idList },
    }),
  municipalPropertyRegister: ({ queryClient, scope: { workspaceId } }: TrashRefreshInput): Promise<void> =>
    refreshMunicipalPropertyManagement({
      queryClient,
      scope: { workspaceId, propertyIdList: [] },
    }),
  municipalPropertyYear: ({ queryClient, scope: { workspaceId } }: TrashRefreshInput): Promise<void> =>
    refreshMunicipalPropertyManagement({
      queryClient,
      scope: { workspaceId, propertyIdList: [] },
    }),
  scenarioModel: invalidateAll(queryKeys.scenarioModels.all),
  dataRequest: invalidateAll(queryKeys.dataRequests.all),
};
export async function refreshTrashEntity({
  queryClient,
  entityType,
  scope,
}: TrashRefreshInput & { entityType: string }): Promise<void> {
  if (!Object.hasOwn(REFRESH_BY_ENTITY_TYPE, entityType)) return;
  await REFRESH_BY_ENTITY_TYPE[entityType as TrashEntityType]({
    queryClient,
    scope,
  });
}
